export default __webpack_public_path__ + "static/media/onnorokom_900.9982a144.gif";